// extracted by mini-css-extract-plugin
module.exports = {"locale":"styles_locale__2xdll"};